declare const PRODUCTION: boolean;
declare const VERSION: string;

export default class GlobalEnvironments {
  public static PRODUCTION: boolean = PRODUCTION;
  public static VERSION: string = VERSION;

  public static getBlockTransportSystemHostUrlForWeb() {
    if (PRODUCTION) {
      return "https://youngintbasecamp2lrs.blob.core.windows.net";
    } else {
      return "https://youngintbasecamp2lrs.blob.core.windows.net";
    }
  }

  public static getBtsWebUrl(resource: string) {
    return `${this.getBlockTransportSystemHostUrlForWeb()}${resource}`;
  }

  public static getBlockTransportSystemSubUrlForWeb() {
    if (PRODUCTION) {
      return "v2";
    }
    return "test";
  }
}
